<div class="sidebar-container">
  <div class="sidebar-header">
    <span class="sidebar-title">Anotações</span>
    <span class="sidebar-badge" *ngIf="anotacoes.length > 0">{{ anotacoes.length }}</span>
    <button mat-icon-button class="sidebar-close-btn" (click)="fechar.emit()" matTooltip="Fechar anotações" aria-label="Fechar anotações">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="sidebar-content">
    <!-- Estado vazio -->
    <div class="empty-state" *ngIf="!carregando && anotacoes.length === 0">
      <mat-icon>note_add</mat-icon>
      <p>Nenhuma anotação ainda</p>
    </div>

    <!-- Loading -->
    <div class="loading-state" *ngIf="carregando">
      <mat-icon>hourglass_empty</mat-icon>
      <p>Carregando...</p>
    </div>

    <!-- Lista de anotações -->
    <div class="anotacoes-lista" *ngIf="!carregando" aria-live="polite">
      <div class="anotacao-item" *ngFor="let anotacao of anotacoes">
        <!-- Modo visualização -->
        <ng-container *ngIf="editandoId !== anotacao.id">
          <div class="anotacao-texto">{{ anotacao.texto }}</div>
          <div class="anotacao-meta">
            <span class="anotacao-pagina" *ngIf="anotacao.pagina">Pág. {{ anotacao.pagina }}</span>
            <span class="anotacao-tempo">{{ formatarTempo(anotacao.criadoEm) }}</span>
            <span class="anotacao-editado" *ngIf="anotacao.editadoEm">(editado)</span>
          </div>
          <!-- Confirmação overlay de exclusão -->
          <div class="anotacao-confirmar-exclusao" *ngIf="excluindoId === anotacao.id">
            <span>Excluir?</span>
            <div class="confirmar-acoes">
              <button mat-icon-button (click)="cancelarExclusao()" aria-label="Cancelar exclusão" matTooltip="Cancelar" class="btn-acao">
                <mat-icon>close</mat-icon>
              </button>
              <button mat-icon-button color="primary" (click)="executarExclusao(anotacao)" aria-label="Confirmar exclusão" matTooltip="Confirmar" class="btn-acao">
                <mat-icon>check</mat-icon>
              </button>
            </div>
          </div>
          <!-- Ações normais -->
          <div class="anotacao-acoes" *ngIf="excluindoId !== anotacao.id">
            <button mat-icon-button (click)="iniciarEdicao(anotacao)" aria-label="Editar anotação" matTooltip="Editar" class="btn-acao">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button (click)="confirmarExclusao(anotacao)" aria-label="Excluir anotação" matTooltip="Excluir" class="btn-acao">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </ng-container>

        <!-- Modo edição -->
        <ng-container *ngIf="editandoId === anotacao.id">
          <textarea class="edit-textarea" [(ngModel)]="editandoTexto" rows="3" aria-label="Editar texto da anotação"></textarea>
          <div class="edit-acoes">
            <input type="number" [(ngModel)]="editandoPagina" placeholder="Pág." min="1" step="1"
              (keydown)="bloquearCaracteresInvalidos($event)" class="pagina-input" aria-label="Página" />
            <span class="edit-spacer"></span>
            <button mat-icon-button (click)="cancelarEdicao()" aria-label="Cancelar edição" matTooltip="Cancelar" class="btn-acao">
              <mat-icon>close</mat-icon>
            </button>
            <button mat-icon-button color="primary" (click)="salvarEdicao(anotacao)" [disabled]="!editandoTexto.trim()" aria-label="Salvar edição" matTooltip="Salvar">
              <mat-icon>check</mat-icon>
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- Formulário de nova anotação -->
  <div class="sidebar-footer">
    <textarea
      class="novo-textarea"
      [(ngModel)]="novoTexto"
      placeholder="Anote observações sobre esta prova..."
      rows="3"
      (keydown.control.enter)="enviar()"
      aria-label="Nova anotação"
    ></textarea>
    <div class="footer-acoes">
      <input type="number" [(ngModel)]="novaPagina" placeholder="Pág." min="1" step="1"
        (keydown)="bloquearCaracteresInvalidos($event)" class="pagina-input" aria-label="Página" />
      <button mat-icon-button color="primary" (click)="enviar()" [disabled]="!novoTexto.trim() || enviando"
        aria-label="Enviar anotação" matTooltip="Enviar (Ctrl+Enter)">
        <mat-icon>send</mat-icon>
      </button>
    </div>
  </div>
</div>
